import { T } from "@/locales/tr";
export default function Terms() {
  return (
    <div data-testid="page-terms" className="max-w-3xl mx-auto px-4 sm:px-8 py-10">
      <div className="text-[11px] uppercase tracking-[0.22em] text-[color:var(--papicoo-accent)]">{T("Conditions générales d'utilisation")}</div>
      <h1 className="font-display text-4xl sm:text-5xl text-[color:var(--papicoo-ink)] mt-2">{T("Conditions d'utilisation")}</h1>
      <p className="text-sm text-[color:var(--papicoo-muted)] mt-2">{T("Dernière mise à jour : juin 2026")}</p>

      <div className="prose prose-sm mt-6 space-y-4 leading-relaxed">
        <h2 className="font-display text-2xl mt-4">{T("1. Objet")}</h2>
        <p>{T("Papicoo est un agent IA personnel développé par et pour Papicoo, Directeur Artistique, Photographe, Web Designer & Maquettiste. Il fournit des services de conseil, d'analyse, de génération de contenu et d'assistance basés sur le Coran, la science, la philosophie et le droit constitutionnel comparé.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("2. Acceptation")}</h2>
        <p>{T("En utilisant Papicoo, vous acceptez ces conditions. Vous certifiez avoir l'âge légal et la capacité juridique requise dans votre pays.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("3. Comportement attendu")}</h2>
        <p>{T("Pas de propos haineux, diffamatoires, racistes, sexistes, complotistes ou contraires à l'esprit du Coran et à la dignité humaine. Papicoo refuse toute demande de propagande ou d'arnaque.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("4. Propriété intellectuelle")}</h2>
        <p>{T("Les portraits générés, contrats, recettes Évoto et autres productions vous appartiennent. La signature « Design by Papicoo » et l'identité visuelle de l'app demeurent la propriété de Papicoo.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("5. Limites de responsabilité")}</h2>
        <p>{T("Papicoo IA produit des conseils et analyses à titre informatif. Pour les questions juridiques, médicales, fiscales ou religieuses sensibles, consultez un professionnel qualifié.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("6. Modifications")}</h2>
        <p>{T("Papicoo peut faire évoluer ces conditions. La date de mise à jour figure en tête.")}</p>

        <h2 className="font-display text-2xl mt-6">{T("7. Droit applicable")}</h2>
        <p>{T("Droit français pour les utilisateurs européens, droit sénégalais pour les utilisateurs au Sénégal, à défaut droit international privé.")}</p>
      </div>
    </div>
  );
}
